export default "__VITE_ASSET__Dct$B4Hz__"